import { render, staticRenderFns } from "./MaterialCard.vue?vue&type=template&id=6b958b7e"
import script from "./MaterialCard.vue?vue&type=script&lang=js"
export * from "./MaterialCard.vue?vue&type=script&lang=js"
import style0 from "./MaterialCard.vue?vue&type=style&index=0&id=6b958b7e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports